import React from 'react'
import { Link } from 'react-router-dom'

import error from '../assets/images/branding/logo-hap.svg'

export default function Error() {
    return (
        <>
            <section className="position-relative bg-soft-primary">
                <div className="container">
                    <div className="row">
                        <div className="col-12 p-0">
                            <div className="d-flex flex-column min-vh-100 justify-content-center px-md-5 py-5 px-4">
                                <div className="text-center">
                                </div>
                                <div className="title-heading text-center my-auto">
                                    <img src={error} className="img-fluid w-25 mb-5" alt="" />
                                    <code>
                                        <h1>404</h1>
                                    </code>
                                    <h3 className="text-dark text-uppercase mt-2 mb-4 fw-bold">Página no encontrada</h3>
                                    <p className="text-muted para-desc mx-auto">Parece que la página que busca no existe.</p>
                                    <div className="mt-4">
                                        <Link to="/" className="btn btn-primary">Volver a Home</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
